import React from "react";
import { NavLink } from "react-router-dom";
import LangToggle from "@/components/header/LangToggle";
import UserMenu from "@/components/header/UserMenu";

/**
 * Mobile fullscreen drawer — renders only when open. Body scroll lock and
 * close-on-route-change live in the parent Header.
 */
export default function MobileMenu({ items }) {
  return (
    <div
      className="lg:hidden fixed inset-0 top-16 bg-ivory z-40 flex flex-col overflow-y-auto"
      data-testid="mobile-menu-panel"
    >
      <nav className="flex flex-col items-center justify-start flex-1 gap-6 px-6 py-8">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className="font-display text-3xl text-charcoal"
            data-testid={`mobile-nav-${item.slug}`}
          >
            {item.label}
          </NavLink>
        ))}
        <span className="brass-rule mt-3" style={{ width: 60 }} />
        <LangToggle className="text-charcoal mt-3" />
        <div className="mt-2 text-charcoal">
          <UserMenu tone="charcoal" />
        </div>
      </nav>
    </div>
  );
}
